import { arrayOf, bool, func, object, string } from 'prop-types';
import React, { useState } from 'react';

import AsyncTable from '../generic/Table/AsyncTable';
import { reactTableColumnShape } from '../prop-types';
import api from '../REST/api';
import ExportAllInvoices from './ExportAllInvoices';

function AsyncList({
  columns,
  allColumns,
  dump,
  searchParams,
  displayExportButton,
  storedName,
  allowSelection,
  setSelectedItems,
}) {
  const [tableFilters, setTableFilters] = useState({});
  return (
    <AsyncTable
      className={allowSelection ? 'select-table' : ''}
      keyField="id"
      allowFilterView
      allowSelection={allowSelection}
      selectionName="invoices"
      minRows={2}
      columns={columns}
      allColumns={allColumns}
      storedName={storedName}
      queryFn={({ search }) => {
        return api.getInvoices({
          search: { ...searchParams, ...search },
        });
      }}
      onDownload={dump ? () => dump(searchParams) : undefined}
      setTableFilters={setTableFilters}
      setSelectedItems={setSelectedItems}
    >
      {displayExportButton && (
        <ExportAllInvoices
          tableFilters={tableFilters}
          searchParams={searchParams}
          className="ml-3"
        />
      )}
    </AsyncTable>
  );
}

AsyncList.propTypes = {
  columns: arrayOf(reactTableColumnShape).isRequired,
  allColumns: arrayOf(reactTableColumnShape).isRequired,
  storedName: string.isRequired,
  searchParams: object, // eslint-disable-line react/forbid-prop-types,
  dump: func,
  displayExportButton: bool,
  allowSelection: bool,
  setSelectedItems: func,
};

AsyncList.defaultProps = {
  searchParams: undefined,
  dump: undefined,
  displayExportButton: false,
  allowSelection: false,
  setSelectedItems: undefined,
};

export default AsyncList;
